import Sentry from "@similarweb/sentry-logger";

import type EcommerceSignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/ecommerce/EcommerceSignalFilters";
import type UISignal from "app/pages/sales-intelligence/sub-modules/signals/models/view/UISignal";
import type UISignalDeps from "app/pages/sales-intelligence/sub-modules/signals/models/view/UISignalDeps";
import type UISignalFactory from "app/pages/sales-intelligence/sub-modules/signals/services/ui-signals/UISignalFactory";

import createEcommerceUISignalNameBuilder from "./ecommerceUISignalNameBuilder";

const ecommerceUISignalFactory: UISignalFactory<EcommerceSignalFilters> = {
    createUISignal(deps: Readonly<UISignalDeps<EcommerceSignalFilters>>): Readonly<UISignal<EcommerceSignalFilters>> {
        const { numberOfAccounts, signal, template } = deps;
        const { alias, description, name, signalSubType, timeframeConfig, signalLifecycleState } = template;
        const nameBuilder = createEcommerceUISignalNameBuilder();

        return {
            ...signal,
            numberOfAccounts,
            signalSubType,
            timeframeConfig,
            signalLifecycleState,
            get name() {
                try {
                    return nameBuilder.buildName(signal);
                } catch (e) {
                    Sentry.error((e as Error).message, e as Error);

                    return name;
                }
            },
            get nameSegments() {
                try {
                    return nameBuilder.buildNameSegments(signal);
                } catch (e) {
                    Sentry.error((e as Error).message, e as Error);

                    return {
                        signalType: {
                            key: "",
                        },
                    };
                }
            },
            template: { alias, description, name },
        };
    },
};

export default ecommerceUISignalFactory;
